// extracted by css-extract-rspack-plugin
export default {"root":"root-HLtaHH","box":"box-KjrmB7"};